module.exports = __webpack_public_path__ + "static/img/cul-images1.ce5755b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg/cul-images1.jpg
// module id = +U8Z
// module chunks = 3